import React, { createContext, useCallback, useContext, useEffect, useState } from "react"
import { FMFile } from "../shared/FMFile"
import { usePath } from "../libs/path/PathProvider"

export type TSelectionContext = {
    selected:FMFile[]
    isSelected:(file:FMFile) => boolean
    addFile:(file:FMFile) => void
    addFiles:(files:FMFile[]) => void
    removeFile:(file:FMFile) => void
    removeAll:()=>void
}

const SelectionContext = createContext<TSelectionContext>({} as any)
export const useSelectionProvider = () => useContext(SelectionContext)

export default function SelectionProvider(props:{children:React.ReactNode}) {
    const {path} = usePath()
    const [selected,setSelected] = useState<FMFile[]>([])
    const isSelected = useCallback((file:FMFile) => selected.findIndex(f => f._id==file._id)>=0, [selected])
    const addFile = (file:FMFile) => setSelected(selected => {
        const index = selected.findIndex(f => f._id==file._id)
        return index<0 ? [...selected,file] : selected
    })
    const addFiles = (files:FMFile[]) => setSelected(selected => {
        const _new:FMFile[] = []
        for(const file of files){
            const index = selected.findIndex(f => f._id==file._id)
            if (index<0) _new.push(file)
        }
        return _new.length ? [...selected,..._new] : selected
    })
    const removeFile = (file:FMFile) => setSelected(selected => {
        const index = selected.findIndex(f => f._id==file._id)
        if (index>=0) {
            selected.splice(index,1)
            return [...selected]
        }
        else return selected
    })
    const removeAll = () => setSelected([])
    useEffect(() => setSelected([]), [path])
    return <SelectionContext.Provider value={{selected,addFile,removeFile,addFiles,removeAll,isSelected}}>{props.children}</SelectionContext.Provider>
}
